import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import constants from 'utils/constants';
import helpers from 'utils/helpers';

const RenderServiceUrl = (props) => {
  const {
    value,
    servicerOriginalId
  } = props;
  const productCode = helpers.getProductCode();
  let servicerDetailUrl = _.get(constants.SERVICER_DETAIL_URL, productCode, '');
  const renderValue = () => {
    if (!_.isEmpty(servicerDetailUrl)) {
      servicerDetailUrl += `/${servicerOriginalId}`;
      return (
        <a href={servicerDetailUrl} target="_blank" rel="noopener noreferrer">
          {value}
        </a>
      );
    } else {
      return (
        <span>{value}</span>
      );
    }
  };
  return (
    <>
      {renderValue()}
    </>
  );
};

RenderServiceUrl.propTypes = {
  value: PropTypes.string.isRequired,
  servicerOriginalId: PropTypes.string
};

RenderServiceUrl.defaultProps = {
  servicerOriginalId: ''
};

export default RenderServiceUrl;
